import {z} from 'zod';

import {BaseVoidResponseSchema} from '@dms/api/shared';

export const GetServiceOrderVehicleClassApiResponseSchema = z
  .object({
    vehicleClassId: z.string(),
  })
  .nullable();

export type GetServiceOrderVehicleClassApiResponse = z.infer<
  typeof GetServiceOrderVehicleClassApiResponseSchema
>;

export const GetServiceOrderVehicleClassApiArgSchema = z.object({
  serviceCaseId: z.string(),
  serviceOrderId: z.string(),
});

export type GetServiceOrderVehicleClassApiArg = z.infer<
  typeof GetServiceOrderVehicleClassApiArgSchema
>;

export const PostServiceOrderAssignVehicleClassApiResponseSchema = BaseVoidResponseSchema;

export type PostServiceOrderAssignVehicleClassApiResponse = z.infer<
  typeof PostServiceOrderAssignVehicleClassApiResponseSchema
>;

export const PostServiceOrderAssignVehicleClassApiArgSchema = z.object({
  serviceCaseId: z.string(),
  serviceOrderId: z.string(),
  vehicleClassId: z.string(),
});

export type PostServiceOrderAssignVehicleClassApiArg = z.infer<
  typeof PostServiceOrderAssignVehicleClassApiArgSchema
>;

export const PostServiceOrderUnassignVehicleClassApiResponseSchema = BaseVoidResponseSchema;

export type PostServiceOrderUnassignVehicleClassApiResponse = z.infer<
  typeof PostServiceOrderUnassignVehicleClassApiResponseSchema
>;

export const PostServiceOrderUnassignVehicleClassApiArgSchema = z.object({
  serviceCaseId: z.string(),
  serviceOrderId: z.string(),
});

export type PostServiceOrderUnassignVehicleClassApiArg = z.infer<
  typeof PostServiceOrderUnassignVehicleClassApiArgSchema
>;
